import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Box from '@material-ui/core/Box/Box';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid/Grid';
import Icon from '@material-ui/core/Icon/Icon';
import Typography from '@material-ui/core/Typography/Typography';
import { createTheme, makeStyles,MuiThemeProvider} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import DrawerPannelV2Footer from "../../passwordManager/drawerPannelV2/drawerPannelV2Footer";

const theme = createTheme({
  typography: {
    fontFamily: [
      '"Montserrat", sans-serif'
    ].join(','),
  },
});

const useStyles = makeStyles(theme => ({

  topPanel:props => ({
    borderRadius: 3,
    background: props.background,
    boxShadow: props.boxShadow,
    textAlign:'center',
    marginLeft:theme.spacing(2),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginTop: '16px',
    // marginTop:-1,
    marginBottom:theme.spacing(2),
  }),
  icon:{
    overflow: 'unset',
    fontSize: '300%',
    textAlign: 'center',
    color:'#fff',
    //margin: theme.spacing(-2.2,0,0,0),
  },
  subTitle:{
    color: '#999',
    marginTop: 0,
    fontWeight: 400,
    [theme.breakpoints.only('xs')]: {
      fontSize:'0.75rem'
    },
  },
  title:props=>({
    color: '#3C4858',
    marginTop: -8,
    fontWeight: 300,
    [theme.breakpoints.only('xs')]: {
      fontSize:'1rem'
    },
  }),
  close: {
    background: 'rgba(0, 0, 0, 0.07)',
    position: 'absolute',
    top: 0,
    right: theme.spacing(2),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '&:hover': {
      background: 'red',
      "& .material-icons":{
        color: '#fff',
      }
    },
  },
  dialogBody:props=>({
    padding: theme.spacing(2),
    backgroundColor: props.secondaryBg,
  }),
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogBoxV2(props) {
  let drawerContent={...props.propsDrawer};
  const classes = useStyles(drawerContent);

  let headerCardGrid=4;
  let headerTextGrid=7;
  let headerIconGrid=3;

  if(drawerContent.width==='sm'){
    headerCardGrid=3;
    headerTextGrid=7;
    headerIconGrid=2
  }else if(drawerContent.width==='md'){
    headerCardGrid=2;
    headerTextGrid=7;
    headerIconGrid=3;
  }else if(drawerContent.width==='lg'){
    headerCardGrid=2;
    headerTextGrid=3;
    headerIconGrid=7;
  }

  return (
    <MuiThemeProvider theme={theme}>
    <Dialog
      open={props.openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={props.closeDialog}
      fullWidth={true}
      maxWidth={drawerContent.width}
    >
      <Grid container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
      >
        <Grid item xs={5} sm={3} md={2} lg={headerCardGrid} xl={headerCardGrid}>
          <Box className={classes.topPanel} >
            <Icon className={classes.icon}>
              {drawerContent.cardIcon}
            </Icon>
          </Box>
        </Grid>

        <Grid item xs={5} sm={7} md={6} lg={headerTextGrid} xl={headerTextGrid}>
          <Box ml={2}>
            <Typography variant="body1" className={classes.subTitle}>
              {drawerContent.subTitle}
            </Typography>
            <Typography variant="h6" className={classes.title}>
              {drawerContent.title}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={2} sm={2} md={4} lg={headerIconGrid} xl={headerIconGrid} >
          <Button onClick={props.closeDialog} size='small' className={classes.close}><Icon fontSize='small'>close</Icon></Button>
        </Grid>

      </Grid>

      <Box className={classes.dialogBody}>
        <Paper>
          {props.children}
        </Paper>
      </Box>

      {props.footer?
        <DrawerPannelV2Footer
          footerLeftBtnData ={props.footerLeftBtnData}
          footerRightBtnData={props.footerRightBtnData}
        />
        :""
      }
    </Dialog>
    </MuiThemeProvider>
  );
}
